import { useEffect, useState } from "react";
import AdminLayout from "layouts/AdminLayout";
import AdminCard from "components/admin/AdminCard";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import {
  RoadmapCard,
  RoadmapColumn,
  listRoadmapCards,
  createRoadmapCard,
  moveRoadmapCard,
  deleteRoadmapCard,
} from "services/admin/adminRoadmap.service";

const COLUMNS: { key: RoadmapColumn; label: string }[] = [
  { key: "planejado", label: "Planejado" },
  { key: "em_desenvolvimento", label: "Em desenvolvimento" },
  { key: "em_testes", label: "Em testes" },
  { key: "publicado", label: "Publicado" },
];

const AdminRoadmap = () => {
  const [cards, setCards] = useState<RoadmapCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [newTitle, setNewTitle] = useState("");
  const [newColumn, setNewColumn] = useState<RoadmapColumn>("planejado");
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    listRoadmapCards()
      .then(setCards)
      .catch((err) => console.error("[AdminRoadmap] erro:", err))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newTitle.trim()) return;
    setSaving(true);
    try {
      await createRoadmapCard({ title: newTitle, column: newColumn });
      setNewTitle("");
      load();
    } catch (err) {
      console.error("[AdminRoadmap] erro ao criar card:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleMove = async (id: number, column: RoadmapColumn) => {
    await moveRoadmapCard(id, column);
    load();
  };

  const handleDelete = async (id: number) => {
    await deleteRoadmapCard(id);
    load();
  };

  return (
    <AdminLayout title="Roadmap" subtitle="Kanban interno de desenvolvimento">
      <div className="flex flex-col gap-6">
        <AdminCard noPadding className="p-4 flex flex-wrap gap-3 items-end" >
          <form onSubmit={handleCreate} className="flex flex-wrap gap-3 items-end w-full">
            <div className="flex-1 min-w-[200px]">
              <Input placeholder="Título do card" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
            </div>
            <select
              className="h-9 rounded-md border border-input bg-background px-3 text-sm"
              value={newColumn}
              onChange={(e) => setNewColumn(e.target.value as RoadmapColumn)}
            >
              {COLUMNS.map((c) => (
                <option key={c.key} value={c.key}>{c.label}</option>
              ))}
            </select>
            <Button type="submit" disabled={saving} className="bg-brand-sidebar hover:bg-brand-sidebar/90">
              Adicionar card
            </Button>
          </form>
        </AdminCard>

        {loading ? (
          <p className="text-sm text-muted-foreground">Carregando...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            {COLUMNS.map((col) => (
              <div key={col.key} className="bg-slate-100/70 rounded-xl p-3 flex flex-col gap-2.5 min-h-[200px]">
                <h3 className="font-semibold text-[13px] text-slate-600 flex items-center justify-between px-1 pt-1">
                  {col.label}
                  <span className="text-xs text-slate-400 font-normal">
                    {cards.filter((c) => c.column === col.key).length}
                  </span>
                </h3>
                {cards
                  .filter((c) => c.column === col.key)
                  .map((card) => (
                    <div key={card.id} className="bg-white rounded-lg p-3 border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,0.04)] flex flex-col gap-2">
                      <p className="text-sm font-medium text-slate-800">{card.title}</p>
                      {card.description && <p className="text-xs text-slate-500">{card.description}</p>}
                      <div className="flex items-center gap-2">
                        <select
                          className="h-7 flex-1 rounded-md border border-input bg-background px-2 text-xs"
                          value={card.column}
                          onChange={(e) => handleMove(card.id, e.target.value as RoadmapColumn)}
                        >
                          {COLUMNS.map((c) => (
                            <option key={c.key} value={c.key}>{c.label}</option>
                          ))}
                        </select>
                        <button
                          className="text-xs text-red-500 hover:underline"
                          onClick={() => handleDelete(card.id)}
                        >
                          Excluir
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminRoadmap;
